/* ParallaxDOMManager is responsible for:
   * managing all parallax instances on the page, ensuring they are measured and applied correctly on window resize
   * restoring scroll position for hash links after measurements are applied (to account for any layout shifts caused by parallax effects)
It expects parallax instances to implement the following methods:
   * isValid(): returns true if the instance has valid configuration and can be registered
   * resetForMeasure(): resets any styles or state that might affect measurements
   * measure(): performs necessary measurements and calculations based on the current DOM state
   * applyMeasurements(): applies the calculated measurements to the DOM (e.g., by setting CSS variables or styles)
*/
export default class ParallaxDOMManager {
    constructor() {
        this.instances = [];
        this.raf = null;

        this.refresh = this.refresh.bind(this);
        this.requestRefresh = this.requestRefresh.bind(this);

        window.addEventListener('resize', this.requestRefresh);
        this.requestRefresh();
    }

    register(instance) {
        if (!instance?.isValid()) return;

        this.instances.push(instance);
    }

    requestRefresh() {
        if (this.raf) return;

        this.raf = requestAnimationFrame(() => {
            this.raf = null;
            this.refresh();
        });
    }

    refresh() {

        this.instances.forEach(instance => instance.resetForMeasure());
        this.instances.forEach(instance => instance.measure());
        this.instances.forEach(instance => instance.applyMeasurements());

        this.restoreHashScroll();
    }

    restoreHashScroll() {
        if(document.body.hasAttribute('data-hash-scroll-restored')) return;
        const hash = window.location.hash;
        if (!hash) return;

        const target = document.querySelector(hash);
        if (!target) return;

        requestAnimationFrame(() => {
            target.scrollIntoView({ block: 'start' });
            document.body.setAttribute('data-hash-scroll-restored', '');
        });
    }
}